import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import HeaderCell from './HeaderCell'

const HeaderGroup = ({ header, children }) => {
  return (
    <div className="fil-table--header-group-row">
      <div className={classNames('fil-table--header-group-row-header', header.extraClasses)}>
        <span>{header.title}</span>
      </div>
      <HeaderCell extraClasses="fil-table--header-group-row-subheader">{children(header.children)}</HeaderCell>
    </div>
  )
}

HeaderGroup.propTypes = {
  header: PropTypes.object.isRequired,
  children: PropTypes.any
}

HeaderGroup.defaultProps = {
  children: null
}

export default HeaderGroup
